var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 505,
    viewBox: "0 0 430 505",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_732_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2376 373.46L31.5458 326.863C26.6346 316.313 11.089 318.228 8.88414 329.654L3.21736 359.021C3.07278 359.77 3 360.532 3 361.295V429.003C3 433.122 5.1121 436.953 8.59488 439.151L54.6692 468.233C55.858 468.983 57.1694 469.519 58.5436 469.815L167.134 493.243C173.573 494.632 179.928 490.571 181.372 484.145L190.177 444.987C191.408 439.511 196.271 435.619 201.885 435.619H276.065C281.691 435.619 286.562 439.529 287.78 445.022L301.433 506.598C302.651 512.091 307.522 516 313.148 516H372.233C380.779 516 386.586 507.32 383.325 499.421L359.593 441.939C357.976 438.022 358.545 433.541 361.09 430.153L375.049 411.57C381.114 403.496 393.832 406.066 396.285 415.862L400.762 433.744C401.073 434.986 401.581 436.171 402.266 437.252L421.976 468.358C427.939 477.768 442.39 474.682 443.989 463.657L458.67 362.424C458.888 360.92 458.818 359.388 458.465 357.91L439.663 279.303C439.445 278.388 439.334 277.451 439.334 276.511V212C439.334 205.373 433.962 200 427.334 200H348.703C342.076 200 336.703 205.373 336.703 212V271.407C336.703 275.473 334.645 279.262 331.235 281.474L181.742 378.463C179.798 379.725 177.529 380.396 175.211 380.396H64.1166C59.4502 380.396 55.207 377.691 53.2376 373.46Z",
    fill: "#3B88CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_732_83",
    x: -197,
    y: 0,
    width: 855.794,
    height: 716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_732_83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBlur);
export default __webpack_public_path__ + "static/media/BottomBlur.523e647cd80e189dbcac45b1884a8f2e.svg";
export { ForwardRef as ReactComponent };